export function getEnvKey(env_value: string | undefined, env_name?: string): string {
  if (typeof env_value !== 'string') {
    const envName = env_name ?? 'Env key'
    throw new Error(`${envName} is undefined!`);
  }
  return env_value;
}